export enum ECompletionYearType {
  HandedOver = 'handedOver',
  CurrentYear = 0,
  InOneYear = 1,
  InTwoYears = 2,
  InThreeYears = 3,
  Later = 4,
}
